import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import '../../css/general.css'
import { useTranslation } from 'react-i18next';
import { FaCheck } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";

const ConfirmModal = (props) => {
    const { t } = useTranslation();
    const [title, setTitle] = useState(null);

    useEffect(() => {
        setTitle(props.title);
    }, [props.title]);

    return (
        <>
            <Modal show={props.show} onHide={props.onHide} className="confirm-modal">
                <Modal.Header closeButton>
                    <Modal.Title className="text-dark">
                        { title }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Footer className="modal-footer-confirm">
                    <Button variant="outline-secondary" style={{ width: '7em' }} onClick={() => { props.decline(); }}><ImCancelCircle className="button-icon" /> {t('No')}</Button>
                    <Button variant="success" style={{ width: '7em' }} className="btn-show-more" onClick={() => { props.accept(); }}><FaCheck className="button-icon" /> {t('Yes')}</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ConfirmModal;